import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=88e76e88&scoped=true"
import script from "./productDetail.vue?vue&type=script&lang=ts"
export * from "./productDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e76e88",
  null
  
)

export default component.exports